import { useEffect, useState, Suspense } from 'react';
import { BrowserRouter, Route, Switch, HashRouter, Link, NavLink, useParams, useRouteMatch, useHistory, useLocation, Redirect } from 'react-router-dom';
import { atom, useRecoilState, useSetRecoilState, useRecoilValue } from 'recoil';
import { rc_menu } from '../../../components/states/atom'

import { CONFIG } from '../../states/settings'
import AppBarHead from '../../common/appbarhead';
import MenuList from '../Menu/list';
import MenuDetail from '../Menu/detail';
import ItemList from '../Item/list';
import ItemDetail from '../Item/detail';
import Search from '../Search/index';


function Top() {
  return (
    <HashRouter>
      <Suspense fallback={<div>loading</div>}>
        <AppBarHead />
      </Suspense>

      <Switch>
        <Route path='/' exact>
          <Index />
        </Route>

        <Route path={`${CONFIG.PAGE_ROOT_PATH}/search`} exact>
          <Suspense fallback={<div>loading</div>}>
            <Search />
          </Suspense>
        </Route>

        <Route path={`${CONFIG.PAGE_ROOT_PATH}/`} exact>
          <Suspense fallback={<div>loading</div>}>
            <MenuList />
          </Suspense>
        </Route>
    
        <Route path={`${CONFIG.PAGE_ROOT_PATH}/:id`} exact>
          <Suspense fallback={<div>loading</div>}>
            <MenuDetail />
          </Suspense>
        </Route>

        <Route path={`${CONFIG.PAGE_ROOT_PATH}/:id/:pagenum`} exact>
          <Suspense fallback={<div>loading</div>}>
            <MenuDetail />
          </Suspense>
        </Route>

        <Route path={`${CONFIG.PAGE_ROOT_PATH}/:id/items`} exact>
          <Suspense fallback={<div>loading</div>}>
            <ItemList />
          </Suspense>
        </Route>

        <Route path={`${CONFIG.PAGE_ROOT_PATH}/:id/items/:entry_id`} exact>
          <Suspense fallback={<div>loading</div>}>
            <ItemDetail />
          </Suspense>
        </Route>

        <Route>
          <NotFount />
        </Route>
      </Switch>
    </HashRouter>
  )
}


function Index() {
  return (
    <>
      <Suspense fallback={<div>loading</div>}>
        <MenuList />
      </Suspense>
    </>
  )
}

function NotFount() {
  return <h2>Page Not Found</h2>
}


export default Top;
